const actionTypes = require('constants/actionTypes');
const apiURLBuilder = require('../core/apiURLBuilder');
const { APIGet, APIPost } = require('utilities/APIRequestHelper');
const signaturePatternActions = require('actions/signaturePattern');
// @ consntans
const {
    FIRST_STEP,
    SECOND_STEP,
    WIZARD_THIRD_STEP,
    WIZARD_SECOND_STEP,
    ENTITY_CODE_ING_API,
    ENTITY_CODE_ING,
    ENTITY_CODE_SANTANDER_API,
    ENTITY_CODE_SANTANDER
} = require('constants/index');

const reset = () => ({ type: actionTypes.BROKER_TRANSFER_VALUES_RESET });

const sendRequest = () => ({
    type: actionTypes.BROKER_TRANSFER_EXTERNAL_REQUEST
});

const setAccountTo = accountId => ({
    type: actionTypes.BROKER_TRANSFER_EXTERNAL_SET_ACCOUNT_TO,
    payload: {
        accountId
    }
});

const setAgencieContract = agencieContract => ({
    type: actionTypes.BROKER_TRANSFER_EXTERNAL_SET_AGENCIE_CONTRACT,
    payload: {
        agencieContract
    }
});

const setISNISO = (isn, iso, currencyCode, value) => ({
    type: actionTypes.BROKER_TRANSFER_EXTERNAL_SET_ISN_ISO,
    payload: {
        isn,
        iso,
        currencyCode,
        value
    }
});

const setTitleAmount = titleAmount => ({
    type: actionTypes.BROKER_TRANSFER_EXTERNAL_SET_TITLE_AMOUNT,
    payload: {
        titleAmount
    }
});

const setVisibleStep = step => ({
    type: actionTypes.BROKER_TRANSFER_EXTERNAL_SET_VISIBLE_STEP,
    payload: {
        step
    }
});

const validateUIStep = step => ({
    type: actionTypes.BROKER_TRANSFER_EXTERNAL_VALIDATE_STEP,
    payload: {
        step
    }
});

const setTypeBoB = (bob) => ({
    type: actionTypes.BROKER_TRANSFER_EXTERNAL_SET_TYPE_BOB,
    payload: {
        bob
    }
 });

 const setTypeAgencie = (agencie) => ({
    type: actionTypes.BROKER_TRANSFER_EXTERNAL_SET_TYPE_AGENCIE,
    payload: {
        agencie
    }
 });


 const setContractBank = (bank) => ({
    type: actionTypes.BROKER_TRANSFER_EXTERNAL_SET_CONTRACT_BANK,
    payload: {
        bank
    }
 });

 const setContractOffice = (office) => ({
    type: actionTypes.BROKER_TRANSFER_EXTERNAL_SET_CONTRACT_OFFICE,
    payload: {
        office
    }
 });

 const setContractDc = (dc) => ({
    type: actionTypes.BROKER_TRANSFER_EXTERNAL_SET_CONTRACT_DC,
    payload: {
        dc
    }
 });

 const setContract = (contract) => ({
    type: actionTypes.BROKER_TRANSFER_EXTERNAL_SET_CONTRACT,
    payload: {
        contract
    }
 });

const transferValuesSuccess = () => ({
    type: actionTypes.BROKER_TRANSFER_EXTERNAL_VALUES_SUCCESS
});

const transferValuesFailure = (error) => ({
    type: actionTypes.BROKER_TRANSFER_EXTERNAL_VALUES_FAILURE,
    payload: {
        error
    }
});

const validationSuccess = (response) => ({
    type: actionTypes.BROKER_TRANSFER_EXTERNAL_VALUES_VALIDATION_SUCCESS,
    payload: {
        response
    }
});

const validationFailure = (error) => ({
    type: actionTypes.BROKER_TRANSFER_EXTERNAL_VALUES_VALIDATION_FAILURE,
    payload: {
        error
    }
});

const getQueryConfirm = function (getState,dataToken) {
    const immTransferValues = getState().brokerTransferExternalValues;
    const immTransferValuesStep1 = immTransferValues.getIn(['steps', FIRST_STEP]);
    const accountId = immTransferValuesStep1.get('accountIdTo');
    const immFunds = getState().brokerTransferExternalFunds.get('funds');
    const account = immFunds.get(accountId);
    const immTransferValuesStep2 = immTransferValues.getIn(['steps', SECOND_STEP]);
    const transferValues = immTransferValues.get('transferValues');
    const agencies = immTransferValuesStep1.get('agencies');
    const agencie = agencies.get(immTransferValuesStep1.get('agencie'));

    let data = {};

    if (immTransferValuesStep1.getIn(['transferType','agencie','value'])) {
        data = {
            'codEmision': immTransferValuesStep2.get('emitionCode'),
            'codPers': transferValues.get('codPers'),
            'codVaiso': transferValues.get('codVaiso'),
            'codValor': immTransferValuesStep2.get('valueCode'),
            'contratoOrigen': immTransferValuesStep1.get('agencieContract'),
            'contratoSel': {
                'numerodecontrato': account.get('walletNumber'),
                'producto': account.get('productNumber'),
            },
            'ctasCer': transferValues.get('ctasCer'),
            'dataToken': dataToken,
            'emprLiq': transferValues.get('emprLiq'),
            'indBolsa': transferValues.get('indBolsa'),
            'indOpe': transferValues.get('indOpe'),
            'numFactu': transferValues.get('numFactu'),
            'numeroVal': transferValues.get('numeroVal'),
            'product': transferValues.get('product'),
            'reftrun': transferValues.get('reftrun'),
            'tcontVaf': transferValues.get('tcontVaf'),
            'tofProce': transferValues.get('tofProce'),
            'intermediario': agencie.get('agencieId')
        };
    } else {
        let originEntity = immTransferValuesStep1.getIn(['contractNumber', 'bank']);
        if (originEntity === ENTITY_CODE_SANTANDER) {
            originEntity = ENTITY_CODE_SANTANDER_API;
        } else if (originEntity === ENTITY_CODE_ING) {
            originEntity = ENTITY_CODE_ING_API;
        }
        data = {
            'codEmision': immTransferValuesStep2.get('emitionCode'),
            'codPers': transferValues.get('codPers'),
            'codVaiso': transferValues.get('codVaiso'),
            'codValor': immTransferValuesStep2.get('valueCode'),
            'contratoSel': {
                'numerodecontrato': account.get('walletNumber'),
                'producto': account.get('productNumber'),
            },
            'ctasCer': transferValues.get('ctasCer'),
            'cuentaOrigenEntidad': originEntity,
            'cuentaOrigenOficina': immTransferValuesStep1.getIn(['contractNumber', 'office']),
            'cuentaOrigenddc': immTransferValuesStep1.getIn(['contractNumber', 'dc']),
            'cuentaOrigenCuenta': immTransferValuesStep1.getIn(['contractNumber', 'contract']),
            'dataToken': dataToken,
            'emprLiq': transferValues.get('emprLiq'),
            'indBolsa': transferValues.get('indBolsa'),
            'indOpe': transferValues.get('indOpe'),
            'numFactu': transferValues.get('numFactu'),
            'numeroVal': transferValues.get('numeroVal'),
            'product': transferValues.get('product'),
            'reftrun': transferValues.get('reftrun'),
            'tcontVaf': transferValues.get('tcontVaf'),
            'tofProce': transferValues.get('tofProce')
        };
    }

    return data;
};

const confirmTransfer = function( dispatch, getState, dataToken) {

    const data = getQueryConfirm(getState,dataToken);

    const requestData = {
        query: data
    };

    dispatch(sendRequest());
    return APIPost(dispatch, apiURLBuilder.getURL('brokerTransferExternalConfirm') , requestData)
        .then(response => dispatch(transferValuesSuccess(response)))
        .catch(response => dispatch(transferValuesFailure(response)))

};

const requestSignaturePatternValidation = () => (dispatch, getState) => {
    const callback = (dispatch, getState, dataToken) => {
        confirmTransfer(dispatch, getState,dataToken);
    };
    signaturePatternActions.validateAndExecute(dispatch, getState, callback);
};

const finish = () => dispatch => {
    dispatch(requestSignaturePatternValidation());
};

const getValidationQueryData = function (getState) {
    const immTransferValues = getState().brokerTransferExternalValues;
    const immTransferValuesStep1 = immTransferValues.getIn(['steps', FIRST_STEP]);
    const accountId = immTransferValuesStep1.get('accountIdTo');
    const immFunds = getState().brokerTransferExternalFunds.get('funds');
    const account = immFunds.get(accountId);
    const agencies = immTransferValuesStep1.get('agencies');
    const agencie = agencies.get(immTransferValuesStep1.get('agencie'));
    const immTransferValuesStep2 = immTransferValues.getIn(['steps', SECOND_STEP]);

    let data = {};

    if (immTransferValuesStep1.getIn(['transferType','agencie','value'])) {
        data = {
            'producto': account.get('productNumber'),
            'numeroContrato': account.get('walletNumber'),
            'contratoOrigen': immTransferValuesStep1.get('agencieContract'),
            'codValor': immTransferValuesStep2.get('valueCode'),
            'codEmision': immTransferValuesStep2.get('emitionCode'),
            'numeroVal': '1.00',
            'intermediario': agencie.get('agencieId'),
            'canalOper': 'KFC',
            'canalComer': 'KFC'
        };
    } else {
        let originEntity = immTransferValuesStep1.getIn(['contractNumber', 'bank']);
        if (originEntity === ENTITY_CODE_SANTANDER) {
            originEntity = ENTITY_CODE_SANTANDER_API;
        } else if (originEntity === ENTITY_CODE_ING) {
            originEntity = ENTITY_CODE_ING_API;
        }
        data = {
            'producto': account.get('productNumber'),
            'numeroContrato': account.get('walletNumber'),
            'cuentaOrigenEntidad': originEntity,
            'cuentaOrigenOficina': immTransferValuesStep1.getIn(['contractNumber', 'office']),
            'cuentaOrigenddc': immTransferValuesStep1.getIn(['contractNumber', 'dc']),
            'cuentaOrigenCuenta': immTransferValuesStep1.getIn(['contractNumber', 'contract']),
            'codValor': immTransferValuesStep2.get('valueCode'),
            'codEmision': immTransferValuesStep2.get('emitionCode'),
            'numeroVal': '1.00',
            'canalOper': 'KFC',
            'canalComer': 'KFC'
        };
    }

    return data;
};

const validateWithAPI = () => (dispatch, getState) => {
    const data = getValidationQueryData(getState);

    const requestData = {
        query: data
    };

    dispatch(sendRequest());
    return APIGet(dispatch, apiURLBuilder.getURL('brokerTransferExternalValidation') , requestData)
        .then(response => dispatch(validationSuccess(response)))
        .catch(response => dispatch(validationFailure(response)))
}

const validateStep = step => (dispatch, getState) => {
    dispatch(validateUIStep(step));
    switch (step) {
        case WIZARD_SECOND_STEP:
            if (getState().brokerTransferExternalValues.getIn(['steps', SECOND_STEP, 'valid'])) {
                dispatch(validateWithAPI());
            }
        break;
        case WIZARD_THIRD_STEP:
            dispatch(finish());
        break;
    }
};

const setWillCancel = willCancel => ({
    type: actionTypes.BROKER_TRANSFER_VALUES_WILL_CANCEL,
    payload: {
        willCancel
    }
});

const requestTraspassFundsSuccess = (response, walletList) => ({
    type: actionTypes.BROKER_GET_TRASPASS_FUNDS_SUCCESS,
    payload: {
        response,
        walletList
    }
});

const requestTraspassFundsError = response => ({
    type: actionTypes.BROKER_GET_TRASPASS_FUNDS_FAILURE,
    payload: {
        response
    }
});


const getTraspassFunds = () => (dispatch, getState) => {

    return APIGet(dispatch, apiURLBuilder.getURL('brokerTransferExternalGetTraspassFunds'))
        .then(response => {
                const walletList = getState().brokerWallets.get('walletList').toList().toJS();
                dispatch(requestTraspassFundsSuccess(response, walletList))
        })
        .catch(response => dispatch(requestTraspassFundsError(response)))

};

const requestAgenciestListSuccess = response => ({
    type: actionTypes.BROKER_TRANSFER_EXTERNAL_GET_AGENCIES_SUCCESS,
    payload: {
        response
    }
});

const requestAgenciestListError = response => ({
    type: actionTypes.BROKER_TRANSFER_EXTERNAL_GET_AGENCIES_ERROR,
    payload: {
        error: response
    }
});

const getAgencies = () => (dispatch) => {

    return APIGet(dispatch, apiURLBuilder.getURL('brokerTransferExternalGetAgencies'))
        .then(response => dispatch(requestAgenciestListSuccess(response)))
        .catch(response => dispatch(requestAgenciestListError(response)))
};

const setAgencie = agencie => ({
    type: actionTypes.BROKER_TRANSFER_EXTERNAL_SET_AGENCIE,
    payload: {
        agencie
    }
});

const getValueAndEmitionCodeSuccess = response => ({
    type: actionTypes.BROKER_TRANSFER_EXTERNAL_GET_EMITION_VALUE_CODE_SUCCESS,
    payload: {
        response
    }
});

const getValueAndEmitionCodeError = response => ({
    type: actionTypes.BROKER_TRANSFER_EXTERNAL_GET_VALUE_AND_EMITION_CODE_ERROR,
    payload: {
        error: response
    }
});

const getValueAndEmitionCode  = () => (dispatch, getState) => {
    const immTransferExternalValues = getState().brokerTransferExternalValues;
    const immTraspassFunds = getState().brokerTransferExternalFunds.get('funds');
    const selectedOption = immTransferExternalValues.getIn(['steps', FIRST_STEP, 'accountIdTo']);
    const selectedAccount = immTraspassFunds.get(selectedOption);

    const data = {
        'producto': selectedAccount.get('productNumber'),
        'numeroContrato': selectedAccount.get('walletNumber'),
        'isin': immTransferExternalValues.getIn(['steps', SECOND_STEP, 'isn']),
        'iso': immTransferExternalValues.getIn(['steps', SECOND_STEP, 'iso']),
        'divisa': immTransferExternalValues.getIn(['steps', SECOND_STEP, 'currencyCode']),
    };

    const requestData = {
        query: data
    };

    return APIGet(dispatch, apiURLBuilder.getURL('brokerTransferExternalGetCodes') , requestData)
        .then(response => dispatch(getValueAndEmitionCodeSuccess(response)))
        .catch(response => dispatch(getValueAndEmitionCodeError(response)))
}



module.exports = {
    reset,
    setVisibleStep,
    validateStep,
    setWillCancel,
    setAccountTo,
    setAgencieContract,
    setISNISO,
    setTitleAmount,
    transferValuesSuccess,
    transferValuesFailure,
    getTraspassFunds,
    getAgencies,
    setAgencie,
    getValueAndEmitionCode,
    finish,
    validateWithAPI,
    setTypeBoB,
    setTypeAgencie,
    setContract,
    setContractBank,
    setContractDc,
    setContractOffice,
}
